import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import selectors from 'shared/store/selectors';

import { PATH } from 'shared/constant';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      rest.auth
        ? (
          <Component {...props} />
        )
        : <Redirect to={PATH.LOGIN} />
    )}
  />
);

const mapStateToProps = state => ({
  // auth: state.authReducer,
  auth: selectors.getToken(state),
  // isAuthenticated: selectors.getIsAuthenticated(state),
});

export default connect(mapStateToProps, null)(PrivateRoute);
